package com.ashes.dev.ai.weather.weathershow

data class LocationData(val latitude: Double, val longitude: Double)

interface LocationProvider {
    suspend fun getCurrentLocation(): LocationData?
    suspend fun getAddressFromLocation(latitude: Double, longitude: Double): String?
    suspend fun getCoordinatesFromAddress(address: String): LocationData?
}

expect fun getLocationProvider(): LocationProvider
